import { render, staticRenderFns } from "./MachineControlPanel.vue?vue&type=template&id=48afb85a&scoped=true&"
import script from "./MachineControlPanel.vue?vue&type=script&lang=js&"
export * from "./MachineControlPanel.vue?vue&type=script&lang=js&"
import style0 from "./MachineControlPanel.vue?vue&type=style&index=0&id=48afb85a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48afb85a",
  null
  
)

export default component.exports